import { render } from "./ModalFacebook.vue?vue&type=template&id=bfdc74c4"
import script from "./ModalFacebook.vue?vue&type=script&lang=js"
export * from "./ModalFacebook.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__